module.exports = __webpack_public_path__ + "components/country-flag/static/sx-2f4c6b6355f349f104ebe5f62450a8b4.svg";